import { useEffect, useState, useRef } from "react";
import MedicineCategoryUI from "./MedicineCategoryUI";
import * as toast from "../../../Wrapper/toast/toast";
import * as apiHelper from "../../../Services/ApiHelper";
import * as stringConstants from "../../../Constants/stringConstants";
import { changeDateFormatForServer } from "../../../Utils/dateUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import * as commonServices from "../../../Services/common";

import * as storageConstants from "../../../Constants/storageConstant";
const MedicineCategory = () => {
  const [modalShow, setModalShow] = useState(false);
  const [medicineList, setMedicineList] = useState([]);
  const [dates, setDates] = useState({ startDate: null, endDate: null });
  const [searchQuery, setSearchQuery] = useState("");
  const [lastSelectedPage, setLastSelectedPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [importModal, setImportModal] = useState(false);
  const [importList, setImportList] = useState();
  const [selectedRows, setSelectedRows] = useState([]);

  const datePickerStartRef = useRef();
  const datePickerEndRef = useRef();

  const handleClose = () => {
    setModalShow(false);
    clearData();
  };

  const initialAddMedicineData = {
    name: "",
    description: "",
    action: "Add",
    id: null,
    status: "",
  };
  const [addMedicineData, setAddMedicineData] = useState(initialAddMedicineData);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    const medicineCategoryState = last_visited_page["medicine_categories"] || null;

    if (medicineCategoryState) {
      if (medicineCategoryState.dates) setDates(medicineCategoryState.dates);
      if (medicineCategoryState.searchQuery) setSearchQuery(medicineCategoryState.searchQuery);
      if (medicineCategoryState.page) setLastSelectedPage(medicineCategoryState.page);
    }
  }, []);

  useEffect(() => {
    const last_visited_page = commonServices.getLocalData(storageConstants.LAST_VISITED_PAGE) || {};
    last_visited_page["medicine_categories"] = {
      dates,
      searchQuery,
      page: lastSelectedPage,
    };
    commonServices.storeLocalData(storageConstants.LAST_VISITED_PAGE, last_visited_page);
  }, [dates, searchQuery, lastSelectedPage]);

  useEffect(() => {
    if (
      (dates.startDate !== null && dates.endDate !== null) ||
      (dates.startDate === null && dates.endDate === null)
    ) {
      getMedicineCategoryList(lastSelectedPage);
    }
  }, [dates]);

  const onPageChange = (page) => {
    getMedicineCategoryList(page);
  };

  const getMedicineCategoryList = (page = 1) => {
    const query = `?page=${page}&limit=10&start_date=${changeDateFormatForServer(dates.startDate)}&end_date=${changeDateFormatForServer(dates.endDate)}&q=${searchQuery}`;
    setLoading(true);
    setLastSelectedPage(page);
    apiHelper
      .getMedicineCategoryList(query)
      .then((response) => {
        if (response?.isSuccess) {
          setMedicineList(response?.data);
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  const clearData = () => {
    setAddMedicineData(initialAddMedicineData);
  };

  const validateData = () => {
    const { name } = addMedicineData;
    let validData = true;

    if (stringUtils.isNullOrEmpty(name)) {
      toast.warn(stringConstants.MEDICINE_CATEGORY_NAME_REQUIRED);
      validData = false;
    } else if (!stringUtils.isValidName(name)) {
      toast.warn(stringConstants.MEDICINE_CATEGORY_LENGTH);
      validData = false;
    }

    return validData;
  };

  const addMedicine = () => {
    if (validateData()) {
      setButtonLoading(true);
      const { name, description, type_id } = addMedicineData;
      apiHelper
        .addMedicineCategory({ name, description, type_id })
        .then((response) => {
          setButtonLoading(false);
          if (response?.isSuccess) {
            getMedicineCategoryList(lastSelectedPage);
            commonServices.fetchSystemData();
            toast.success(response.message);
            setModalShow(false);
            clearData();
          } else {
            toast.warn(response?.message);
          }
        })
        .catch((error) => {
          toast.warn(error);
        })
        .finally(() => {
          setButtonLoading(false);
        });
    }
  };

  const Action = (data, action = "") => {
    if (action === "edit") {
      setAddMedicineData({
        name: data.name,
        description: data.description,
        action: "Edit",
        id: data.id,
      });

      setModalShow(true);
    }
  };

  const editMedicine = (id) => {
    if (validateData()) {
      setButtonLoading(true);
      const { name, description, type_id } = addMedicineData;
      apiHelper.editMedicineCategory(id, { name, description, type_id: 1 }).then((response) => {
        setButtonLoading(false);
        if (response?.isSuccess) {
          getMedicineCategoryList(lastSelectedPage);
          commonServices.fetchSystemData();
          toast.success(response.message);
          setModalShow(false);
          clearData();
        } else {
          toast.warn(response?.message);
        }
      });
    }
  };
  const importListing = (data) => {
    if (importModal) {
      setLoading(true);
      apiHelper
        .importMaster("medicine_category", data)
        .then((response) => {
          if (response?.isSuccess) {
            setImportList(response?.data);
          }
        })
        .catch((err) => toast.warn(err))
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const openImportModal = () => {
    setImportModal(true);
  };

  const exportList = () => {
    setButtonLoading(true);
    apiHelper
      .exportMaster("medicine_category", { ids: selectedRows })
      .then((response) => {
        if (response?.isSuccess) {
          toast.success(response?.message);
          getMedicineCategoryList(lastSelectedPage);
          commonServices.fetchSystemData(setLoading);
        } else {
          toast.warn(response.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => {
        setButtonLoading(false);
        setImportModal(false);
      });
  };

  const statusHandler = (data) => {
    const updatedStatus = data.status === "ACTIVE" ? "INACTIVE" : "ACTIVE";
    setAddMedicineData({ ...addMedicineData, status: updatedStatus });
    setButtonLoading(true);

    apiHelper.changeMedicineCategoryStatus(data.id, { status: updatedStatus }).then((response) => {
      setButtonLoading(false);
      if (response?.isSuccess) {
        getMedicineCategoryList(lastSelectedPage);
        commonServices.fetchSystemData();
        toast.success(response.message);
        setModalShow(false);
        clearData();
      } else {
        toast.warn(response?.message);
      }
    });
  };

  return (
    <>
      <MedicineCategoryUI
        modalShow={modalShow}
        setModalShow={setModalShow}
        handleClose={handleClose}
        medicineList={medicineList}
        addMedicineData={addMedicineData}
        setAddMedicineData={setAddMedicineData}
        dates={dates}
        setDates={setDates}
        datePickerStartRef={datePickerStartRef}
        datePickerEndRef={datePickerEndRef}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        addMedicine={addMedicine}
        onPageChange={onPageChange}
        editMedicine={editMedicine}
        loading={loading}
        buttonLoading={buttonLoading}
        Action={Action}
        showConfirmModal={showConfirmModal}
        setShowConfirmModal={setShowConfirmModal}
        getMedicineCategoryList={getMedicineCategoryList}
        statusHandler={statusHandler}
        importListing={importListing}
        exportList={exportList}
        importModal={importModal}
        importList={importList}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
        setImportModal={setImportModal}
        openImportModal={openImportModal}
      />
    </>
  );
};

export default MedicineCategory;
